export const WEB_PUSH_GAME_MARKER = 'notification'

const GAME_PATH_PATTERN = /^\/play\/([\w-]{1,128})$/

export function webPushGameIdFromLocation(
  pathname: string,
  search: string,
): string | null {
  const match = GAME_PATH_PATTERN.exec(pathname)
  if (!match)
    return null
  const params = new URLSearchParams(search)
  const entries = [...params.entries()]
  return entries.length === 1 && params.get(WEB_PUSH_GAME_MARKER) === '1'
    ? match[1]
    : null
}

export function webPushGameReturnTargetFromLocation(
  pathname: string,
  search: string,
): string | null {
  return webPushGameIdFromLocation(pathname, search) === null
    ? null
    : `${pathname}${search}`
}

export interface WebPushGameDestinationIdentity {
  expectedUserId: string
  expectedSessionId: string
  gameId: string
}

export async function resolveWebPushGameDestination(
  identity: WebPushGameDestinationIdentity,
  canOpen: (
    input: WebPushGameDestinationIdentity,
  ) => Promise<{ available: boolean }>,
): Promise<string> {
  try {
    const { available } = await canOpen(identity)
    return available ? `/play/${identity.gameId}` : '/'
  }
  catch {
    return '/'
  }
}
